var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeautyActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E1E3E3;}\n\t.st4{fill:#FFD1D1;}\n\t.st5{fill:none;}\n\t.st6{fill:#0A1514;}\n\t.st7{fill:#C0C3C3;}\n\t.st8{fill:#821bb8;}\n\t.st9{fill:#677371;}\n\t.st10{fill:none;stroke:#677371;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#F8D1CF;}\n\t.st12{fill:#EE8B88;}\n\t.st13{display:inline;fill:#C0C3C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -495,
    y: -2150,
    className: "st2",
    width: 800,
    height: 3706
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.5,11.5C23.2,10,21.8,8,19.8,8c-0.9,0-1.6,0.3-2.1,0.6c1.1,0.7,2,1.9,2.9,2.9c1.7,1.9,4,3.2,6.5,3.3 c0,0-3.3,9.9-13,11.1c0.6,0.1,1.3,0.1,2,0.1c11.2,0,15-11.2,15-11.2C28.5,14.7,26.3,13.5,24.5,11.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3,8.5c0.4,0,0.8-0.2,1.1-0.4C4.3,7.8,4.5,7.4,4.5,7c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.3C4.2,6.1,4.1,6,4.1,5.9C4,5.9,3.9,5.8,3.8,5.8c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1 c-0.5-0.1-1,0.1-1.4,0.4C1.7,6.2,1.5,6.6,1.5,7c0,0.4,0.2,0.8,0.4,1.1C2.2,8.3,2.6,8.5,3,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32,14.9c0-0.2,0-0.4-0.1-0.6c-0.2-0.3-0.5-0.4-0.8-0.4c-2.6-0.1-4.6-1.6-5.7-2.9c-0.2-0.2-0.4-0.5-0.6-0.7 C23.5,8.8,22,7,19.8,7c-1.8,0-3,0.8-3.8,1.6C15.3,7.8,14.1,7,12.2,7C10,7,8.5,8.8,7.3,10.2c-0.2,0.2-0.4,0.5-0.6,0.7 c-1.2,1.3-3.1,2.8-5.7,2.9c-0.3,0-0.6,0.2-0.8,0.4C0.1,14.4,0,14.6,0,14.9c0,0.3,0,0.6,0.2,0.8C1.3,18,5.7,27,16,27 c10.4,0,14.8-9.1,15.7-11.4C31.9,15.4,32,15.2,32,14.9z M8.2,12.2c0.2-0.2,0.4-0.5,0.6-0.7C9.9,10.3,11,9,12.2,9 c2.1,0,2.8,1.7,2.8,1.8c0.1,0.4,0.5,0.6,0.9,0.6c0.4,0,0.8-0.2,0.9-0.6c0-0.1,0.8-1.8,2.8-1.8c1.3,0,2.4,1.3,3.4,2.5 c0.2,0.3,0.4,0.5,0.6,0.7c1.1,1.3,2.4,2.2,3.8,2.8c-10.5,2.9-19.1,1.3-23.4,0.1C5.7,14.5,7,13.5,8.2,12.2z M16,25 c-7.4,0-11.3-5.1-13-8.2c2.5,0.8,6.9,1.9,12.6,1.9c3.9,0,8.5-0.5,13.4-2C27.3,19.8,23.4,25,16,25z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cm",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyActive);
export default __webpack_public_path__ + "static/media/beauty-active.200238c1701cc32051ab8b1ab88589af.svg";
export { ForwardRef as ReactComponent };